import { Put } from '../helpers';

export function UpdatePublishSettings(
  project_uuid: string,
  isLocked?: boolean,
  dmaID?: string | null
): Promise<{ is_publish_locked: boolean; dma_id: string }> {
  return Put({
    path: `/v3/admin/event/${project_uuid}/publish-settings`,
    body: { isLocked, dmaID },
  });
}
